export default "__VITE_ASSET__CL4Y2C5b__"